import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

export default new VueI18n({
  locale: 'en',
  messages: {
    en: Object.assign({}, require('./../src/locale/en.json')),
    cn: Object.assign({}, require('./../src/locale/cn.json')),
    tw: Object.assign({}, require('./../src/locale/cn_tw.json')),
    bm: Object.assign({}, require('./../src/locale/bm.json')),
  },
});